import React from 'react'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import _ from 'underscore'

import { ConsolidatedEvent } from 'types/ConsolidatedEvent'

import { color } from 'styles/colors'

type Props = {
  consolidatedEvents: ConsolidatedEvent[];
  query: string | null;
}

const ConsolidatedEventsList = ({ consolidatedEvents, query }: Props) => {
  return (
    <S.ConsolidatedEventsList data-testid="events">
      <S.Header>
        <S.Title>Consolidated Events</S.Title>
      </S.Header>
      <S.Section data-testid="consolidated-events" key="consolidated-events">
        {_.map(_.sortBy(consolidatedEvents, (event) => event.name), (event) => (
          <S.Event
            to={`?q=${query}&id=${event.id}`}
            key={event.id}
          >
            {event.name}
          </S.Event>
        )
        )}
      </S.Section>
    </S.ConsolidatedEventsList>
  )
}

export default ConsolidatedEventsList

const S = {
  ConsolidatedEventsList: styled.div`
    margin-top: 30px;
  `,
  Header: styled.div`
    position: relative;
    padding-bottom: 5px;
    border-bottom: 1px solid ${color('divider')};
  `,
  Title: styled.h2`
    display: inline-block;
    margin-right: 10px;
    color: ${color('titleText')};
  `,
  Section: styled.div`
    margin-top: 15px;
  `,
  Event: styled(NavLink)`
    display: block;
  `
}
